import type { ChangeEvent } from 'react';
import { useState } from 'react';
import { ChatBubbleIcon, Cross2Icon } from '@radix-ui/react-icons';
import { Button, Dialog, TextField } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'validator/es/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import { isLoggedIn } from 'helpers/authentication';
import Analytics from 'ui/design-base/Analytics';
import { invite } from 'store/invitation/invitationSlice';
import { useAppDispatch } from 'store/store';

export const InviteDialog: React.FC<{ currentUser: boolean }> = ({ currentUser }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState('');

  const onMessageClickFunction = () => {
    Analytics.sendEvent({
      category: 'Profile Interaction',
      action: 'Show Message Modal',
      label: 'Player Header',
    });
    if (!isLoggedIn()) {
      navigate('/accedi');
    }
  };

  const isValid = () => [!isEmpty(email) && isEmail(email)].every((isValid) => isValid);

  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <Button variant='outline' className='min-w-20 hover:cursor-pointer' onClick={onMessageClickFunction}>
          <ChatBubbleIcon />
          Invita
        </Button>
      </Dialog.Trigger>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>
            {currentUser ? 'Invita un amico ad iscriversi' : 'Invita il giocatore ad iscriversi'}
          </Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>Scrivi al giocatore - contattalo tramite il form</Dialog.Description>

        <div className='flex flex-1 flex-row flex-wrap items-center justify-center gap-4'>
          <TextField.Root
            size='2'
            className='flex-1'
            placeholder='Inserisci la mail'
            value={email}
            onChange={(event: ChangeEvent<{ value: string }>) => {
              setEmail(event.target.value);
            }}
          />
          <Button
            disabled={!isValid()}
            className='hover:cursor-pointer'
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              e.preventDefault();
              dispatch(invite(email));
            }}
          >
            Invita
          </Button>
        </div>
        {email !== '' && !isEmail(email) && (
          <p className='text-sm font-bold text-red-9'>Questo indirizzo e-mail non sembra valido...</p>
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default InviteDialog;
